import React, { FunctionComponent } from 'react'
import Svg, { G, Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

type Props = {
  size?: number | string
  fillColor?: string
}

export const ClipboardPlus: FunctionComponent<Props> = ({ size = 32, fillColor }) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconActive

  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none' testID={tID('ClipboardPlus')}>
      <G transform='translate(4.6667 3.3333)'>
        <Path
          d='M18 2.66667H17.3333C17.3333 0.972 16.3613 0 14.6667 0H8C6.30533 0 5.33333 0.972 5.33333 2.66667H4.66667C1.61333 2.66667 0 4.28 0 7.33333V20.6667C0 23.72 1.61333 25.3333 4.66667 25.3333H18C21.0533 25.3333 22.6667 23.72 22.6667 20.6667V7.33333C22.6667 4.28 21.0533 2.66667 18 2.66667ZM6.66667 2.66667C6.66667 1.70667 7.04 1.33333 8 1.33333H14.6667C15.6267 1.33333 16 1.70667 16 2.66667V4C16 4.96 15.6267 5.33333 14.6667 5.33333H8C7.04 5.33333 6.66667 4.96 6.66667 4V2.66667ZM21.3333 20.6667C21.3333 22.972 20.3053 24 18 24H4.66667C2.36133 24 1.33333 22.972 1.33333 20.6667V7.33333C1.33333 5.028 2.36133 4 4.66667 4H5.33333C5.33333 5.69467 6.30533 6.66667 8 6.66667H14.6667C16.3613 6.66667 17.3333 5.69467 17.3333 4H18C20.3053 4 21.3333 5.028 21.3333 7.33333V20.6667ZM15.3333 14.6667C15.3333 15.0347 15.0347 15.3333 14.6667 15.3333H12V18C12 18.368 11.7013 18.6667 11.3333 18.6667C10.9653 18.6667 10.6667 18.368 10.6667 18V15.3333H8C7.632 15.3333 7.33333 15.0347 7.33333 14.6667C7.33333 14.2987 7.632 14 8 14H10.6667V11.3333C10.6667 10.9653 10.9653 10.6667 11.3333 10.6667C11.7013 10.6667 12 10.9653 12 11.3333V14H14.6667C15.0347 14 15.3333 14.2987 15.3333 14.6667Z'
          fill={fill}
        />
      </G>
    </Svg>
  )
}
